import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { faqQueryKeys } from "../query-keys/faq.query-keys";
import { FaqQuestionType } from "@ac-expo/api-types";

async function getFaqQuestions() {
  const { data } = await privateAxios.get<FaqQuestionType[]>("/faq-questions");
  return data;
}

export const useGetFaqQuestionsQuery = () => {
  return useQuery({
    queryKey: faqQueryKeys.all,
    queryFn: getFaqQuestions,
  });
};
